import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconClock10",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], m = ["id"];
function _(e, t, r, h, g, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--clock-10"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Clock 10",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" }, null, -1),
      a("path", { d: "M6 2.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.724.447l-2-1a.5.5 0 1 1 .448-.894L5.5 5.19V3a.5.5 0 0 1 .5-.5Z" }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, p);
}
const C = /* @__PURE__ */ u(c, [["render", _]]);
export {
  C as default
};
//# sourceMappingURL=clock-10.js.map
